<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加小节</Button>
          </Col>
          <Col span="5">
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="productItemName" label="小节名称" :show-tooltip-when-overflow="true"></el-table-column>
        <!--<el-table-column prop="duration" label="时长" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="isUpdated" label="是否更新" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="isFree" label="是否免费" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="isPermission" label="许可证" :show-tooltip-when-overflow="true"></el-table-column>-->
        <!--<el-table-column prop="isLatest" label="是否最新" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="url" label="视频ID"></el-table-column>
        <el-table-column prop="fid" label="上传视频" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a target="_blank" :href="'/api/productonline/productItem/ui8?id='+scope.row.url">点击查看</a>
            <!--<div v-if="scope.row.fid">已上传，<a target="_blank" :href="'/api/upload/mp4/'+scope.row.uuid">点击查看</a>-->
            <!--</div>-->
            <!--<div v-else>未上传</div>-->
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="100">

        <!--<FormItem label="上传视频" required>-->
          <!--<UploadOne v-model="detail.fid"></UploadOne>-->
          <!--只支持mp4格式-->
        <!--</FormItem>-->
				<FormItem label="小节名称" required>
					<Input v-model="detail.productItemName"/>
				</FormItem>

        <FormItem label="阿里云视频ID" required>
          <Input v-model="detail.url"/>
        </FormItem>

				<!--<FormItem label="时长（秒）">-->
					<!--<Input v-model="detail.duration" type="number"/>-->
				<!--</FormItem>-->
				<!--<FormItem label="是否更新">-->
					<!--<Input v-model="detail.isUpdated"/>-->
				<!--</FormItem>-->
				<!--<FormItem label="是否免费">-->
					<!--<Input v-model="detail.isFree"/>-->
				<!--</FormItem>-->
				<!--<FormItem label="许可证">-->
					<!--<Input v-model="detail.isPermission"/>-->
				<!--</FormItem>-->
				<!--<FormItem label="是否最新">-->
					<!--<Input v-model="detail.isLatest"/>-->
				<!--</FormItem>-->
      </Form>
    </Modal>

  </div>
</template>

<script>
  import UploadOne from '@/public/upload/UploadOne'
  export default {
    components:{UploadOne},
    props:['chapterId'],
    data(){
      return{
        baseUrl:'/api/productonline/productItem/',
        list:[],
        page:1,
        count:0,
        limit:1000,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        params.push('t.chapterId@=@'+this.chapterId);
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.chapterId = this.chapterId;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    },
    watch: {
      chapterId: {
      handler(newValue, oldValue) {
        this.load();
      },
      deep: true
    }
  }
  }
</script>



// WEBPACK FOOTER //
// src/components/product/online/ProductItem.vue